module.exports = __webpack_public_path__ + "img/pic1.0a150c77.png";